<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div  @click="defaultMask" class="mask" key="1" v-if="show" @touchmove.prevent></div>

    <div class="operatePop" v-show="show" key="2">
      <div class="operatePop-title">
        <span class="operatePop-title-name">设备操作</span>
        <el-button class="operatePop-title-close" type="text" icon="el-icon-close" @click="close"></el-button>
      </div>

      <div class="operatePop-sign">
        <div class="operatePop-sign-name">
          <span class="operatePop-sign-nameOpt">设备编号</span>
        </div>
        <div class="operatePop-sign-value">
          <span class="operatePop-sign-valueOpt">{{deviceAddr}}</span>
        </div>
      </div>
      <div class="operatePop-line"></div>

      <div class="operatePop-middle">
        <div class="operatePop-middle-title">系统设置</div>
        <div class="operatePop-middle-content">
          <div class="operatePop-middle-contentOpt">
            <span style="cursor: pointer" @click="reStart">系统重启</span>
          </div>
        </div>
      </div>
      <div class="operatePop-line" />

      <div  class="operatePop-middle">
        <div class="operatePop-middle-title">拍照设置</div>
        <div class="operatePop-middle-content">
          <div class="operatePop-middle-contentOpt">
            <span style="cursor: pointer" @click="setPhoto()">立即拍照</span>
          </div>
        </div>
      </div>
      <div class="operatePop-line"></div>

      <div class="operatePop-bottom">
        <div class="operatePop-bottom-title">定时拍照设备</div>
        <div class="operatePop-bottom-content">
          <div class="operatePop-bottom-contentOpt">
            <el-input placeholder= "15:00,16:00,17:00" v-model="photoTime"></el-input>
            <el-button type="primary" @click="onSubmit()" style="margin-top: 2%">确定</el-button>
          </div>
        </div>
      </div>

    </div>
  </transition-group>
</template>

<script>
  export default {
    name: 'deviceOperate',
    data() {
      return {
        deviceAddr: '',
        show: false,
        photoTime: '15:00,16:00,17:00',
      }
    },

    created() {},

    mounted() {
    },

    methods: {
      /**
       * 设备软重启
       */
      reStart() {
        this.$confirm('请确定是否进行设备重启','提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {//确定设备重启
          let that = this;
          let param = {"deviceId": this.deviceAddr, "orderType": "reboot", "orderValue": "XC+REBOOT"};
          console.log("设备重启", param);
          this.$SporePestCommon.setOrder(param, function (response) {
              if(response.data.code == 200) { //设备软重启成功
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '设备重启成功'
                })
              } else {//设备软重启失败
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '设备重启失败'
                })
              }
            })
        }).catch(() => {//设备软重启取消
          this.$message({
            showClose: true,
            type: 'warning',
            message: '设备重启已取消'
          })
        })
      },

      /**
       * 设备立即拍照
       */
      setPhoto() {
        this.$confirm('请确定是否立即拍照', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {//确定拍照
          let that = this;
          let param = {"deviceId": this.deviceAddr, "orderType": "capture", "orderValue": "XC+CAPTURE"};
          console.log("拍照", param);
          this.$SporePestCommon.setOrder(param, function (response) {
            if(response.data.code == 200) { //设备拍照成功
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '拍照成功'
                })
            } else { //设备拍照失败
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '拍照失败'
                })
            }
          })
        }).catch(() => { //设备拍照取消
          this.$message({
            showClose: true,
            type: 'warning',
            message: '立即拍照已取消'
          })
        })
      },

      /**
       * 设置拍照时间点
       */
      onSubmit() {
        this.$confirm('请确定是否设置拍照时间点', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => { //确定设置拍照时间点
          let that = this;
          let arrList = [];
          arrList = this.photoTime.toString().split(",");
          let param = {"deviceId": this.deviceAddr, "orderType": "captureTime", "orderValue": arrList};
          console.log("设置拍照时间", param);
          this.$SporePestCommon.setOrder(param, function (response) {
            if(response.data.code == 200) { //设置拍照时间成功
              that.$message({
                showClose: true,
                type: 'success',
                message: '设置拍照时间点成功'
              })
            } else { //设置拍照时间点失败
              that.$message({
                showClose: true,
                type: 'warning',
                message: '设置拍照时间点失败'
              })
            }
          })
        }).catch(() => { //设置拍照时间点取消
          this.$message({
            showClose: true,
            type: 'warning',
            message: '设置拍照时间点已取消'
          })
        })
      },

      /**
       * 关闭
       */
      close() {
        this.show =false;
      },

      /**
       * 点击空余部分关闭
       */
      defaultMask() {
        this.show = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }
  // 全局弹窗
  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
  }

  .operatePop {
    height: 40%;
    width: 25%;
    background: #2B5DA0;
    border-radius: 8px;
    position: fixed;
    top: 30%;
    left: 45%;
    margin-left: -10%;
    z-index: 20;

    .operatePop-title {
      width: 100%;
      height: 13%;
      display: table;
      color: #ffffff;
      font-size: 26px;
      font-family: SimSun;

      .operatePop-title-name {
        display: table-cell;
        vertical-align: middle;
        padding-left: 40%
      }

      .operatePop-title-close {
        float: right;
        padding: 3px 3px;
        color: cyan;
      }
    }

    .operatePop-sign {
      height: 13%;
      width: 100%;
      display: flex;
      flex-direction: row;
      font-size: 24px;
      color: #ffffff;
      font-family: SimSun;

      .operatePop-sign-name {
        width: 40%;
        height: 100%;
        display: table;

        .operatePop-sign-nameOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center
        }
      }

      .operatePop-sign-value {
        width: 60%;
        height: 100%;
        display: table;

        .operatePop-sign-valueOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center
        }
      }
    }

    .operatePop-middle {
      width: 100%;
      height: 16%;
      font-family: SimSun;

      .operatePop-middle-title {
        width: 100%;
        height: 40%;
        color: #ffffff;
        font-size: 16px;
        padding-left:2%;
        padding-top: 2%
      }

      .operatePop-middle-content {
        width: 100%;
        height: 60%;
        display: table;
        color: #5BDAFB;
        font-size: 24px;

        .operatePop-middle-contentOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center;
        }
      }
    }

    .operatePop-line {
      width:96%;
      height:0.1%;
      margin-left: 2%;
      background-color: cyan
    }

    .operatePop-bottom {
      width: 100%;
      height: 40%;
      font-family: SimSun;

      .operatePop-bottom-title {
        width: 100%;
        height: 30%;
        color: #ffffff;
        font-size: 16px;
        padding-left: 2%;
        padding-top: 2%;
      }

      .operatePop-bottom-content {
        width: 100%;
        height: 70%;
        display: table;

        .operatePop-bottom-contentOpt {
          display: table-cell;
          vertical-align: middle;
          text-align: center
        }
      }
    }

    .el-card {
      background-color:transparent;
      border: none;
    }

    /deep/ .el-input__inner {
      background-color: transparent;
      border: 1px solid #4CD7E3;
      color: #ffffff;
      width: 60%;
    }

    /deep/ .el-input__icon{
      font-size:24px;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/deviceOperate.vue